import { BookCrossIcon } from './BookCrossIcon';

/**
 * author: Christopher Schreiner
 * id CC30F9D0-3076-4189-A00D-F570D5B0C5D1
 * name book-cross
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/book-cross.svg
 * tags
 * - Religion 
 */
export const BibleIcon = BookCrossIcon;
export default BibleIcon